import { cn } from '@/lib/utils';
import type { AppLanguage } from '@/lib/language';

interface Props {
  id?: string;
  value: AppLanguage;
  onChange: (language: AppLanguage) => void;
  className?: string;
}

export default function LanguageSelector({ id, value, onChange, className }: Props) {
  const nextLanguage: AppLanguage = value === 'en-US' ? 'sr-RS' : 'en-US';
  const nextLanguageName = nextLanguage === 'en-US' ? 'English' : 'Serbian';

  return (
    <button
      id={id}
      type="button"
      onClick={() => onChange(nextLanguage)}
      aria-label={`Switch to ${nextLanguageName}`}
      title={`Switch to ${nextLanguageName}`}
      className={cn(
        'fongpt-hover group inline-grid h-11 w-11 shrink-0 cursor-pointer place-items-center rounded-xl border border-outline bg-surface text-xs font-bold tracking-wide text-primary shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        className
      )}
    >
      <span key={value} className="language-toggle-label">
        {value === 'en-US' ? 'EN' : 'SR'}
      </span>
    </button>
  );
}
